export const BASE_LAYOUT_HEADER_HEIGHT = 65;
export const BASE_LAYOUT_CONTENT_PADDING = 10;
export const BASE_LAYOUT_CONTENT_HEIGHT = 20;
export const BASE_BLUE_COLOR = '#1890FF';
